import styled from "styled-components";
import { colors, types } from "../../../libs";

export const Panel = styled.div`
  width: 100%;
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  @media (max-width: 760px) {
    align-items: stretch;
    flex-direction: column;
  }
`;
export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;
export const HeaderCopy = styled.div`
  min-width: 0;
`;
export const BackButton = styled.button`
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 50%;
  border: 0;
  background: ${colors.background.lightGrey};
  color: ${colors.text.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Title = styled.div`
  ${types.headers.itemMedium};
  color: ${colors.text.white};
  line-height: 1.25;
`;
export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 6px;
  max-width: 620px;
`;
export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  > button {
    width: auto;
    min-width: 142px;
    padding-left: 18px;
    padding-right: 18px;
    white-space: nowrap;
  }
  @media (max-width: 760px) {
    align-self: flex-end;
  }
  @media (max-width: 440px) {
    align-self: stretch;
    flex-direction: column;
    > button {
      width: 100%;
    }
  }
`;
export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
`;
export const TableWrapper = styled.div`
  margin-top: 24px;
  overflow-x: auto;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${colors.text.white};
  th {
    ${types.body.small};
    color: ${colors.text.gray};
    font-weight: normal;
    text-align: left;
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  td {
    ${types.body.normal};
    padding: 13px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    vertical-align: middle;
  }
`;
export const Status = styled.span<{ $active: boolean }>`
  ${types.body.small};
  color: ${({ $active }) => ($active ? colors.text.green : colors.text.gray)};
  padding: 4px 9px;
  border-radius: 14px;
  background: ${colors.background.lightGrey};
  white-space: nowrap;
`;
export const Code = styled.code`
  color: ${colors.text.white};
  background: ${colors.background.formField};
  padding: 4px 7px;
  border-radius: 4px;
`;
export const UserButton = styled.button`
  ${types.body.normal};
  border: 0;
  background: transparent;
  color: ${colors.text.white};
  padding: 0;
  text-align: left;
  &:hover {
    color: ${colors.text.green};
    text-decoration: underline;
  }
`;
export const CountButton = styled.button`
  ${types.body.normal};
  border: 0;
  background: transparent;
  color: ${colors.text.white};
  padding: 4px 8px;
  border-radius: 4px;
  &:hover {
    background: ${colors.background.lightGrey};
    color: ${colors.text.green};
  }
`;
export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;
export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 4px;
  padding: 7px 10px;
  color: ${colors.text.white};
  background: ${colors.background.lightGrey};
  white-space: nowrap;
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
export const NotesButton = styled(CopyButton)`
  color: ${colors.text.green};
`;
export const EmptyState = styled.div`
  ${types.body.normal};
  color: ${colors.text.gray};
  text-align: center;
  padding: 42px 12px;
`;
